import React from "react";
import { motion } from "framer-motion";
import Header from "./Header";
import { logos } from "../data";
import { fadeIn, staggerContainer } from "../variants";

const Hero = () => {
  return (
    <section className="min-h-[750px] bg-herosm lg:bg-hero bg-cover bg-right relative">
      {" "}
      {/* Add relative positioning */}
      <Header />
      <div className="container mx-auto min-h-[750px] flex justify-center items-center relative">
        {" "}
        {/* Add relative positioning */}
        <motion.div
          initial="hidden"
          whileInView={"show"}
          variants={staggerContainer(0.3, 1)}
          className="text-center flex flex-col items-center absolute inset-0 justify-end lg:justify-start"
        >
          <motion.div variants={fadeIn("down", "tween", 0.5, 1.1)}>
            <img
              className={
                "w-[500px] h-[500px] lg:w-[1000px] lg:h-[1000px] filter drop-shadow-[0_10px_3px_rgba(0,0,0,0.40)] object-cover"
              }
              src={logos.default}
              alt=""
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
